// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"TradeGuarantee__wrapper__1ZDuN","moveUp":"TradeGuarantee__moveUp__1I7_Q","title":"TradeGuarantee__title__3FO8F","iconWrapper":"TradeGuarantee__iconWrapper__ZmWOc","tooltip":"TradeGuarantee__tooltip__3Wdcz","tooltipInner":"TradeGuarantee__tooltipInner__Fn9Rx","icon":"TradeGuarantee__icon__2GLUw","tooltipTitle":"TradeGuarantee__tooltipTitle__31FZZ","tooltipDescription":"TradeGuarantee__tooltipDescription__eWvTM"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Sidebar/styles/TradeGuarantee.scss
// module id = 3060
// module chunks = 4